import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';
import { View } from '../../../component';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { isSmartPhone } from '../../../utilities/helper';
import MatchTabBarMWeb from './index_mWeb';
import useTheme from '../../../utilities/hooks/theme';
interface Props {
  onChangeTab?: any;
  activeTab?: number;
  routes?: any;
}
const MatchTabBar = ({ onChangeTab, activeTab, routes = [] }: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const tabSX: SxProps<Theme> = {
    '& .MuiTabs-scroller': {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '& .MuiTabs-flexContainer': {
      flex: 1,
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    }
  };
  if (isSmartPhone) {
    return <MatchTabBarMWeb activeTab={activeTab} onChangeTab={onChangeTab} routes={routes} />;
  }
  return (
    <View
      style={{
        display: 'flex',
        // flex: 1,
        width: '60%',
        backgroundColor: 'transparent'
      }}>
      <Tabs
        TabIndicatorProps={{ style: { background: 'transparent' } }}
        onChange={onChangeTab}
        value={activeTab}
        sx={tabSX}
        style={{
          flex: 1,
          minHeight: 0,
          padding: 0,
          display: 'flex',
          // alignItems: 'center',
          width: '100%'
        }}>
        {routes.map((item: any, index: any) => {
          const { key, title } = item;
          const isActive = activeTab === index;
          return (
            <Tab
              key={key}
              style={{
                flex: 1,
                // width: index == 1 ? '20%' : '40%',
                minHeight: 0,
                padding: 0,
                fontSize: '16px',
                fontFamily: 'Poppins',
                fontWeight: 600,
                // fontFamily: isActive ? 'ProximaNova-Bold' : 'ProximaNova-Regular',
                background: isActive ? theme.matchTabActivebg : theme.matchTabDefaultBg,
                color: isActive ? '#000' : '#fff',
                textTransform: 'none',
                height: '40px',
                borderLeft: index === 1 ? '0.5px solid #808594' : '',
                borderRight: index === 1 ? '0.5px solid #808594' : ''
              }}
              label={`${title}`}
              value={index}
            />
          );
        })}
      </Tabs>
    </View>
  );
};
export default React.memo(MatchTabBar);
